export const moduleKey = 'core'
export const roles = {
    settings: {
        name: 'Configurações',
        key: `${moduleKey}:settings`,
        permissions: {
            read: {
                name: 'Visualizar / Editar',
                description: 'Permite visualizar as configurações',
                key: `${moduleKey}:settings:read`,
            },
        },
    },
    // Keys consumed by the odforge operations panel (embedded at /operations);
    // the backend maps the highest one to OPERACIONAL / GESTAO / ADMIN.
    operations: {
        name: 'Painel operacional',
        key: 'operations',
        permissions: {
            read: {
                name: 'Visualizar',
                description:
                    'Permite acompanhar eventos, falhas e integrações do painel operacional',
                key: 'operations:read',
            },
            manage: {
                name: 'Gerenciar',
                description:
                    'Permite reprocessar eventos, etapas e jobs no painel operacional',
                key: 'operations:manage',
            },
            admin: {
                name: 'Administrar',
                description:
                    'Acesso total ao painel operacional, incluindo integrações',
                key: 'operations:admin',
            },
        },
    },
}
